export default "__VITE_ASSET__7db2e0f5__"